import { css } from '@emotion/react'

import { rem } from '@groovehq/internal-design-system/lib/util'

// UserSelection component uses these styles too.
const dropdownContainer = css`
  & > * {
    width: 100%;
  }
`

const dropdownBtn = css`
  min-width: 100%;
`

const checkboxList = css`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(16)};
  & > *:not(:first-of-type) {
    margin-top: ${rem(14)};
  }
`

export const styles = {
  checkboxList,
  dropdownContainer,
  dropdownBtn,
}
